export const TABLE_PADDING_COMMON = {
  padding: 5,
}

export const TABLE_PADDING_LEFT = {
  paddingLeft: 8,
}
